<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-door"
          :title="$t('select doortype')"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-tabs v-model="tab" background-color="gray" dark right v-else>
            <v-tab key="all">{{ $t("all") }}</v-tab>
            <v-tab key="favorites">{{ $t("favorites") }}</v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item key="all">
                <v-data-iterator
                  :items="filteredDoorType"
                  :items-per-page="100"
                  hide-default-footer
                  ><template v-slot:header>
                    <v-toolbar class="mb-1">
                      <v-text-field
                        v-model.lazy="filters.width"
                        clearable
                        hide-details
                        prepend-inner-icon="mdi-search"
                        :label="$t('width')"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model.lazy="filters.height"
                        clearable
                        hide-details
                        :label="$t('height')"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <v-select
                        v-model="filters.category"
                        hide-details
                        :items="categories"
                        item-value="id"
                        item-text="name"
                        prepend-inner-icon="mdi-search"
                        :label="$t('category')"
                        clearable
                      ></v-select>
                      <v-spacer></v-spacer>
                      <!--                <v-select-->
                      <!--                  v-model="filters.tags"-->
                      <!--                  hide-details-->
                      <!--                  :items="tags"-->
                      <!--                  item-value="id"-->
                      <!--                  item-text="name"-->
                      <!--                  prepend-inner-icon="mdi-search"-->
                      <!--                  :label="$t('tags')"-->
                      <!--                  multiple-->
                      <!--                  clearable-->
                      <!--                ></v-select>-->

                      <v-select
                        v-model="filters.properties"
                        hide-details
                        :items="properties"
                        item-value="id"
                        item-text="name"
                        prepend-inner-icon="mdi-search"
                        :label="$t('properties')"
                        :menu-props="{ maxHeight: '400' }"
                        multiple
                      ></v-select>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="filters.search"
                        clearable
                        hide-details
                        prepend-inner-icon="mdi-search"
                        :label="$t('search')"
                      ></v-text-field>
                    </v-toolbar>
                  </template>
                  <template v-slot:default="props">
                    <v-row class="mt-2">
                      <v-col
                        v-for="item in props.items"
                        :key="item.id"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                      >
                        <v-card
                          @click="selectType(item)"
                          color="#eee"
                          image
                          class="pa-1"
                        >
                          <v-img
                            v-if="item.icon"
                            :src="item.icon | addToken"
                            max-height="125"
                            contain
                            flat
                            class="pb-1"
                            title="Test"
                          >
                          </v-img>
                          <v-img
                            src="/img/tmp/default.png"
                            max-height="125"
                            contain
                            flat
                            v-else
                          >
                          </v-img>
                          <v-card-text>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  class="float-right mr-1"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-rectangle-outline
                                </v-icon>
                              </template>
                              <span>{{ item.glass_info }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  class="float-right mr-1"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>{{ item.description }}</span>
                            </v-tooltip>
                            <v-icon
                              class="float-right mrr-1"
                              :title="
                                $t('Einbruchschutz') +
                                  ' ' +
                                  item.bulgary_resistence
                              "
                              v-if="
                                item.bulgary_resistence &&
                                  item.bulgary_resistence != 0
                              "
                              >mdi-lock</v-icon
                            >
                            <v-icon
                              class="float-right mr-1"
                              :title="
                                $t('Brandschutzklasse') +
                                  ' ' +
                                  item.fire_behaviour
                              "
                              v-if="
                                item.fire_behaviour &&
                                  item.fire_behaviour != 'npd' &&
                                  item.fire_behaviour != 'NPD'
                              "
                              >mdi-fire</v-icon
                            >
                            <v-icon
                              class="float-right mr-1"
                              :title="$t('Schallschutz') + ' ' + item.rw_value"
                              v-if="
                                item.rw_value && parseFloat(item.rw_value) > 0
                              "
                              >mdi-wifi</v-icon
                            >
                            <v-icon
                              class="float-right mr-1"
                              :title="
                                $t('smoke_protection') +
                                  ' ' +
                                  item.smoke_protection
                              "
                              v-if="
                                item.smoke_protection &&
                                  item.smoke_protection != 'npd' &&
                                  item.smoke_protection != 'NPD'
                              "
                              >mdi-smoking</v-icon
                            >

                            {{ item.code }} - {{ item.name }}
                            <br />
                            <v-btn
                              color="light"
                              rounded
                              small
                              class="mt-2"
                              :title="$t('sketches')"
                              @click.stop="openSketchesDialog(item)"
                            >
                              <v-icon>mdi-image-multiple</v-icon>
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-iterator>
              </v-tab-item>
              <v-tab-item key="favorites">
                <v-data-table
                  :headers="favoritesHeaders"
                  :items="favorites"
                  :loading="loading"
                  :multi-sort="true"
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-options': [10, 15, 50, -1]
                  }"
                >
                  <template v-slot:item.name="{ item }">
                    <a @click="selectedFavoriteCallback(item)">{{
                      item.name
                    }}</a>
                  </template>
                  <template v-slot:item.door_type.code="{ item }">
                    <a @click="selectedFavoriteCallback(item)">{{
                      item.door_type.code
                    }}</a>
                  </template>
                  <template v-slot:item.door_type.name="{ item }">
                    <a @click="selectedFavoriteCallback(item)">{{
                      item.door_type.name
                    }}</a>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon small @click="deleteFavorite(item)">
                      mdi-delete
                    </v-icon>
                    <v-icon small @click="editFavorite(item)">
                      mdi-pencil
                    </v-icon>
                  </template></v-data-table
                >
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <v-dialog v-model="dialog" max-width="500" v-if="dialog">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary float-right" dark v-bind="attrs" v-on="on">
                {{ $t("edit_favorite") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">
                {{ $t("edit_favorite") }}
              </v-card-title>
              <v-card-text
                ><v-text-field
                  v-model="favorite_edit.name"
                  :label="$t('favorite_name') + '*'"
                  v-validate="''"
                  data-vv-name="favorite_edit.name"
                  :error-messages="errors.collect('favorite_edit.name')"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialog = false">
                  {{ $t("back") }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="_storeFavoriteName(favorite_edit)"
                >
                  {{ $t("save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="sketchesDialog" max-width="800">
            <v-card>
              <v-card-title class="d-flex align-center">
                <span>{{ $t("sketches") }}</span>
                <v-spacer></v-spacer>
                <v-icon
                  size="large"
                  @click="sketchesDialog = false"
                  :aria-label="$t('Close')"
                  >mdi-close</v-icon
                >
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col
                    v-for="(sketch, i) in sketchesToShow"
                    :key="sketch.id || i"
                    cols="12"
                  >
                    <a :href="sketch.url | addToken" target="_blank">
                      <v-img
                        :src="sketch.url | addToken"
                        :alt="sketch.name || $t('Sketch')"
                        max-height="200"
                        width="100%"
                        contain
                      ></v-img>
                    </a>
                    <div class="caption">{{ sketch.name }}</div>
                    <hr class="my-5" />
                  </v-col>
                </v-row>
                <div v-if="!sketchesToShow.length">
                  {{ $t("No sketches available") }}
                </div>

                <div v-if="drawingsToShow.length">
                  <h3 class="mb-2">{{ $t("drawings") }}</h3>
                  <ul class="drawing-list">
                    <li
                      v-for="(drawing, i) in drawingsToShow"
                      :key="'download-link-' + (drawing.id || i)"
                    >
                      <a
                        :href="drawing.url | addToken"
                        target="_blank"
                        download
                      >
                        {{ drawing.name || $t("Drawing") }}
                      </a>
                    </li>
                  </ul>
                  <hr class="my-5" />
                </div>

                <div class="text-center">
                  <v-btn color="primary" @click="sketchesDialog = false">
                    {{ $t("close") }}
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  fetchDoorTypes,
  saveOrderline,
  toogleFavorite,
  fetchFavorites,
  deleteFavorite,
  storeFavorite
} from "../shared/services";
import {
  fetchTypeCategories,
  fetchTags
} from "../../doorTypes/shared/services";
import { fetchItem as fetchDoorType } from "../../doorTypes/shared/services";
export default {
  name: "app-doorType-item",
  props: {
    selectedTypeCallback: null,
    order: null,
    selectedFavoriteCallback: null
  },
  data() {
    return {
      loading: true,
      doorTypes: [],
      filters: {
        category: null,
        search: "",
        tags: [],
        width: null,
        height: null,
        properties: []
      },
      categories: [],
      tags: [],
      properties: [
        { name: "RC2", id: "RC2" },
        { name: "RC3", id: "RC3" },
        { name: "EI 30", id: "fire_behaviour-ei30" },
        { name: "EI 60", id: "fire_behaviour-ei60" },
        { name: "> 32dB", id: "rw_value-32" },
        { name: "> 37dB", id: "rw_value-37" },
        { name: "> 42dB", id: "rw_value-42" },
        { name: "Einflügelig", id: "type-flg1" },
        { name: "Doppelflügelig", id: "type-flg2" },
        { name: "1 Seitenteil", id: "type-st1" },
        { name: "2 Seitenteile", id: "type-st2" },
        { name: "Oberlichte", id: "type-ol" },
        { name: "Glasausschnitt", id: "glass" },
        { name: "Flächenbündig einseitig", id: "flush1" },
        { name: "Flächenbündig zweiseitig", id: "flush2" },
        { name: "Rauchschutz Sa", id: "smoking-sa" },
        { name: "Rauchschutz S200", id: "smoking-s200" }
      ],
      tab: 0,
      favorites: [],
      dialog: null,
      favorite_id: null,
      favorite_edit: null,
      sketchesDialog: false,
      sketchesToShow: [],
      drawingsToShow: []
    };
  },
  mounted() {
    // eslint-disable-next-line no-console
    console.log("mounted start");
    this.init();
    fetchTypeCategories().then(res => {
      this.categories = res.data;
    });
    fetchTags().then(res => {
      this.tags = res.data;
    });
    // eslint-disable-next-line no-console
    console.log("mounted end");
  },
  computed: {
    filteredRei() {
      let result = this.filters.properties;
      return result
        .filter(item => item.startsWith("fire_behaviour"))
        .map(function(x) {
          return x.replace(/fire_behaviour-/g, "");
        });
    },

    filteredSmoke() {
      let result = this.filters.properties;
      return result
        .filter(item => item.startsWith("smoking"))
        .map(function(x) {
          return x.replace(/smoking-/g, "");
        });
    },
    filteredOneSash() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("type-flg1"));
    },
    filteredTwoSash() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("type-flg2"));
    },
    filteredOl() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("type-ol"));
    },
    filteredSt1() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("type-st1"));
    },
    filteredSt2() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("type-st2"));
    },
    filteredRc() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("RC"));
    },

    filteredGlass() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("glass"));
    },

    filteredRw() {
      let result = this.filters.properties;
      return result
        .filter(item => item.startsWith("rw_value-"))
        .map(function(x) {
          return x.replace(/rw_value-/g, "");
        });
    },
    filteredFlush() {
      let result = this.filters.properties;
      return result.filter(item => item.startsWith("flush"));
    },

    filteredDoorType() {
      let result = this.doorTypes;
      if (this.filters.category) {
        // eslint-disable-next-line no-console
        console.log("category filter");
        result = result.filter(doorType => {
          return doorType.door_type_category_id == this.filters.category;
        });
      }
      if (this.filters.tags.length) {
        // eslint-disable-next-line no-console
        console.log("tags filter");
        result = result.filter(doorType => {
          return doorType.tags.some(tag => {
            return this.filters.tags.includes(tag);
          });
        });
      }
      if (this.filters.width) {
        // eslint-disable-next-line no-console
        console.log("width filter");

        result = result.filter(doorType => {
          if (
            Number.parseInt(doorType.width_min) <=
              Number.parseInt(this.filters.width) &&
            Number.parseInt(this.filters.width) <=
              Number.parseInt(doorType.width_max)
          ) {
            return true;
          }
          return false;
        });
      }
      if (this.filters.height) {
        // eslint-disable-next-line no-console
        console.log("height filter");

        result = result.filter(doorType => {
          if (
            Number.parseInt(doorType.height_min) <=
              Number.parseInt(this.filters.height) &&
            Number.parseInt(this.filters.height) <=
              Number.parseInt(doorType.height_max)
          ) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredRc.length) {
        result = result.filter(doorType => {
          if (this.filteredRc.indexOf(doorType.bulgary_resistence) !== -1) {
            return true;
          }
          return false;
        });
      }
      if (this.filteredGlass.length) {
        result = result.filter(doorType => {
          if (doorType.glass > 0) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredFlush.length) {
        if (this.filteredFlush[0] == "flush1") {
          result = result.filter(doorType => {
            if (doorType.flush == "1") {
              return true;
            }
            return false;
          });
        }
        if (this.filteredFlush[0] == "flush2") {
          result = result.filter(doorType => {
            if (doorType.flush == "2") {
              return true;
            }
            return false;
          });
        }
        if (this.filteredFlush.length == 2) {
          if (this.filteredFlush[1] == "flush1") {
            result = result.filter(doorType => {
              if (doorType.flush == "1") {
                return true;
              }
              return false;
            });
          }
          if (this.filteredFlush[1] == "flush2") {
            result = result.filter(doorType => {
              if (doorType.flush == "2") {
                return true;
              }
              return false;
            });
          }
        }
      }

      if (this.filteredOneSash.length) {
        // eslint-disable-next-line no-console
        console.log("filteredType filter");
        result = result.filter(doorType => {
          if (
            doorType.parts.includes("flg1") &&
            !doorType.parts.includes("flg2")
          ) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredTwoSash.length) {
        result = result.filter(doorType => {
          if (
            doorType.parts.includes("flg1") &&
            doorType.parts.includes("flg2")
          ) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredOl.length) {
        result = result.filter(doorType => {
          if (
            doorType.parts.includes("flg1") &&
            doorType.parts.includes("ol")
          ) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredSt1.length) {
        result = result.filter(doorType => {
          if (
            (doorType.parts.includes("st1") &&
              !doorType.parts.includes("st2")) ||
            (!doorType.parts.includes("st1") && doorType.parts.includes("st2"))
          ) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredSt2.length) {
        result = result.filter(doorType => {
          if (
            doorType.parts.includes("st1") &&
            doorType.parts.includes("st2")
          ) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredRei.length) {
        // eslint-disable-next-line no-console
        console.log("filteredRei filter");
        result = result.filter(doorType => {
          if (this.filteredRei.indexOf(doorType.fire_behaviour) !== -1) {
            return true;
          }
          return false;
        });
      }

      if (this.filteredSmoke.length) {
        // eslint-disable-next-line no-console
        console.log("filteredSmoke filter");
        result = result.filter(doorType => {
          const smokeProtection = doorType.smoke_protection
            ? doorType.smoke_protection.toLowerCase()
            : null;

          if (
            smokeProtection &&
            smokeProtection.search(this.filteredSmoke[0]) !== -1
          ) {
            return true;
          }

          if (
            this.filteredSmoke[1] &&
            smokeProtection &&
            smokeProtection.search(this.filteredSmoke[1]) !== -1
          ) {
            return true;
          }

          return false;
        });
      }

      if (this.filteredRw.length) {
        // eslint-disable-next-line no-console
        console.log("filteredRw filter");
        let min = Math.max(...this.filteredRw);

        result = result.filter(doorType => {
          if (min <= parseFloat(doorType.rw_value)) {
            return true;
          }
          return false;
        });
      }

      if (this.filters.search) {
        // eslint-disable-next-line no-console
        console.log("search filter");
        result = result.filter(doorType => {
          let name = doorType.name.toLowerCase();
          let code = doorType.code.toLowerCase();
          let description = "";
          if (doorType.description) {
            description = doorType.description.toLowerCase();
          }

          return (
            name.indexOf(this.filters.search.toLowerCase()) > -1 ||
            description.indexOf(this.filters.search.toLowerCase()) > -1 ||
            code.indexOf(this.filters.search.toLowerCase()) > -1
          );
        });
      }

      return result;
    },
    favoritesHeaders() {
      return [
        {
          text: this.$t("Name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("Code"),
          align: "left",
          value: "door_type.code"
        },
        {
          text: this.$t("Doortype"),
          align: "left",
          value: "door_type.name"
        },
        { text: "", value: "action", sortable: false }
      ];
    }
  },
  methods: {
    init() {
      // eslint-disable-next-line no-console
      fetchDoorTypes({ order_id: this.order }).then(res => {
        this.doorTypes = _.orderBy(res.data, ["code"], "asc");
        fetchFavorites().then(res => {
          this.favorites = res.data.filter(fav => {
            return !!this.doorTypes.find(dt => {
              return dt.id == fav.door_type.id;
            });
          });
        });
        this.loading = false;
        // eslint-disable-next-line no-console
      });
    },
    async deleteFavorite(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Favorite?")
        )
      ) {
        let resp = await deleteFavorite(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.init();
      }
    },
    editFavorite(item) {
      this.dialog = true;
      this.favorite_edit = { ...item };
    },
    async _storeFavoriteName(favorite) {
      this.$validator.reset();
      this.$validator.validateAll();
      this.$forceUpdate();
      let resp = await storeFavorite(
        favorite.id,
        { name: favorite.name },
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.favorite_name = "";
        fetchFavorites().then(res => {
          this.favorites = res.data.filter(fav => {
            return !!this.doorTypes.find(dt => {
              return dt.id == fav.door_type.id;
            });
          });
        });
        this.dialog = false;
      } else {
        return Promise.reject();
      }
    },
    selectType(item) {
      fetchDoorType(item.id).then(res => {
        this.selectedTypeCallback(res.data);
      });
    },
    openSketchesDialog(item) {
      const useDocuments = docs => {
        if (!docs || !Array.isArray(docs)) return [];
        const sketchDocs = docs.filter(doc => doc.type === "sketches");
        return sketchDocs.reduce((acc, doc) => {
          if (doc.files && Array.isArray(doc.files)) {
            return acc.concat(doc.files);
          }
          if (doc.url) {
            return acc.concat([{ id: doc.id, name: doc.name, url: doc.url }]);
          }
          return acc;
        }, []);
      };
      const useDrawings = docs => {
        if (!docs || !Array.isArray(docs)) return [];
        const drawingDocs = docs.filter(doc => doc.type === "drawings");
        return drawingDocs.reduce((acc, doc) => {
          if (doc.files && Array.isArray(doc.files)) {
            return acc.concat(doc.files);
          }
          if (doc.url) {
            return acc.concat([{ id: doc.id, name: doc.name, url: doc.url }]);
          }
          return acc;
        }, []);
      };
      if (item.documents && item.documents.length) {
        this.sketchesToShow = useDocuments(item.documents);
        this.drawingsToShow = useDrawings(item.documents);
        this.sketchesDialog = true;
      } else {
        fetchDoorType(item.id).then(res => {
          this.sketchesToShow = useDocuments(res.data && res.data.documents);
          this.drawingsToShow = useDrawings(res.data && res.data.documents);
          this.sketchesDialog = true;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
